// extracted by mini-css-extract-plugin
export default {"header":"bepaling-detail_header__0oIMY","header_title":"bepaling-detail_header_title__fPPEq"};